import { signOut } from 'next-auth/react';

export const handleLogout = async (router) => {
  // Clear all auth-related data
  localStorage.removeItem('token');
  localStorage.removeItem('userData');

  // Sign out from NextAuth
  await signOut({ redirect: false });

  // Store current path for redirect after login if needed
  const currentPath = router.asPath;
  if (currentPath !== '/login') {
    localStorage.setItem('redirectUrl', currentPath);
  }

  // Redirect to login page
  router.push('/login');
};